import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleShowDiscountsModal, handleShowDiscountsPanel, resetDiscountNew } from '../../action';
// import { countDown } from '../../redux/reducers/utils';
import { const_var, params } from '../../redux/reducers/reducer';
 
const Discounts = () => {
    const state = useSelector((state) => state.reducer);
    const dispatch = useDispatch();
    const [updatedPercentage , setUpdatedPercentage] = useState(0)
    const [updateTimer,setUpdateTimer] = useState(false)
    const [showPopUp , setPopUp] = useState(false)
    useEffect(() => {
        
        let date = state.discount_Offers_end_date
        let id = "timer"
        if (!date) return;
 
        const countdownDate = new Date(`${date} 23:59:59`).getTime();  
        const elements = {
            [id]: document.getElementById(id),
            timer: document.getElementById("timer"),
            discountTimer: document.getElementById("discountTimer")
        };
     
        if(countdownDate == undefined){
            return ''
        }
        const interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = countdownDate - now;
       
            if (distance < 0) {
                clearInterval(interval);
                Object.values(elements).forEach(element => {
                    if (element){
                        element.innerHTML = "Expired";
                        if(showPopUp == false){
                            dispatch(resetDiscountNew(true))
                            setPopUp(true)
                        }
                    }
                });
                return;
            }
   
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
   
            let valStyle = 'font-size: 26px; font-weight: 900; color: #FFFFFF; z-index: 999999999; margin-right: 4px; margin-left: 4px;';
            let titleStyle = 'font-size: 12px; font-weight: 500; color: #FFFFFF; display: content; margin-right: 4px; margin-left: 4px;';
            let mobileValStyle = 'font-size: 14px; font-weight: 900; color: #FFFFFF; z-index: 999999999; margin-right: 1px; margin-left: 1px;';
            let mobileTitleStyle = 'font-size: 8px; font-weight: 500; color: #FFFFFF; margin-right: 1px; margin-left: 1px;';
            let timerValStyle = window.innerWidth < 1025 ? (window.innerWidth > 450 ? 'font-size: 18px; font-weight: 900; color: #FFFFFF; z-index: 999999999 margin-right: 2px; margin-left: 2px;' : mobileValStyle) : valStyle;
            let timertitleStyle = window.innerWidth < 1025 ? (window.innerWidth > 450 ? 'font-size: 10px; font-weight: 500; color: #FFFFFF; margin-right: 2px; margin-left: 2px;' : mobileTitleStyle) : titleStyle;
            let discountTimerValStyle = window.innerWidth < 414 ? 'font-size: 18px; font-weight: 900; color: #FFFFFF; z-index: 999999999; margin-right: 2px; margin-left: 2px;' : valStyle;
            let discountTimertitleStyle = window.innerWidth < 414 ? 'font-size: 10px; font-weight: 500; color: #FFFFFF; margin-right: 2px; margin-left: 2px;' : titleStyle;
 
            let timerContent = `
                <div style="${timerValStyle}">${days}</div>
                <div style="${timertitleStyle}">${days > 1 ? 'DAYS' : 'DAY'}</div>
                <div style="margin-left:3px; margin-right:3px;">:</div>
                <div style="${timerValStyle}">${hours}</div>
                <div style="${timertitleStyle}">${hours > 1 ? 'HRS' : 'HR'}</div>
                <div style="margin-left:3px; margin-right:3px;">:</div>
                <div style="${timerValStyle}">${minutes}</div>
                <div style="${timertitleStyle}">${minutes > 1 ? 'MINS' : 'MIN'}</div>
                `;
                // <div>:</div>
                // <div style="font-size: 26px; font-weight: 900; color: #FFFFFF;">${seconds}</div>
                // <div style="font-size: 12px; font-weight: 500; color: #FFFFFF; display: content;">SECONDS</div>
 
            let discountTimerContent = `
                <div style="${discountTimerValStyle}">${days}</div>
                <div style="${discountTimertitleStyle}">${days > 1 ? 'DAYS' : 'DAY'}</div>
                <div style="margin-left:3px; margin-right:3px;">:</div>
                <div style="${discountTimerValStyle}">${hours}</div>
                <div style="${discountTimertitleStyle}">${hours > 1 ? 'HRS' : 'HR'}</div>
                <div style="margin-left:3px; margin-right:3px;">:</div>
                <div style="${discountTimerValStyle}">${minutes}</div>
                <div style="${discountTimertitleStyle}">${minutes > 1 ? 'MINS' : 'MIN'}</div>
                `;
                // <div>:</div>
                // <div style="font-size: 26px; font-weight: 900; color: #FFFFFF;">${seconds}</div>
                // <div style="font-size: 12px; font-weight: 500; color: #FFFFFF; display: content;">SECONDS</div>
           
            if (elements[id]) elements[id].innerHTML = timerContent;
            if (elements.timer) elements.timer.innerHTML = timerContent;
            if (elements.discountTimer) elements.discountTimer.innerHTML = discountTimerContent;
   
        }, 500);
 
        return ()=>{
            clearInterval(interval)
            setUpdateTimer(false)
        }
 
 
    },[state.discount_banner,state.discount_Offers_end_date,params.m_s_n, updateTimer])
    // },[state.discount_banner,const_var.discount_Offers_end_date,params.m_s_n, params.m_n_f_2 == '', params.m_n_f_1 == ''])
 
    const updateTimerFn=()=>{
        setUpdateTimer(true)
        return ''
    }
    let checkOffer = true;
    if(state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount']!=undefined && state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n]!=undefined)
    {
      if(state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n]!=undefined && state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n].length==0)
      {
        checkOffer = false;
      }
    }
    return (
        <>  {
                state.isShowDiscountsPanel &&
                <div className={state.discount_banner ? 'discounts-container' : 'discounts-container d-none'} >
                    <div className='discounts-title announcing-title'>
                        {
                            // const_var.loginSession == true
                            // ?
                            //     state?.discount_Offers?.length > 0 && state?.discount_Offers[0]?.manufacturer.name + "Announcing special Discount -"
                            // :
                                "SPECIALS -"
                        }
                    </div>
                    <div className={state?.higherOfferPercentage && checkOffer ? 'discounts-comment' : "d-none"}>
                        UP TO {state?.higherOfferPercentage && parseFloat(state?.higherOfferPercentage)}% OFF -
                    </div>
                    <div className='discounts-title'>
                        Offer Ends In -
                    </div>
                    <div className='discounts-time' id="timer">
                        {/* { countDown(const_var.discount_Offers_end_date, "timer")} */}
                        {!updateTimer && updateTimerFn()}
                        {/* <div className='discounts-time-item'>
                            <div className='item-value'>02</div>
                            <div className='item-title'>Days</div>
                        </div>
                        <div>:</div>
                        <div className='discounts-time-item'>
                            <div className='item-value'>01</div>
                            <div className='item-title'>HRS</div>
                        </div>
                        <div>:</div>
                        <div className='discounts-time-item'>
                            <div className='item-value'>08</div>
                            <div className='item-title'>MINS</div>
                        </div> */}
                    </div>
                    <div className='discounts-view-details' onClick={() => dispatch(handleShowDiscountsModal())}>
                        {window.innerWidth > 768 ? <span>VIEW DETAILS</span> : <span>DETAILS</span>}
                       
                        <span className='icon-arrow-thin-right'></span>
                    </div>
                    {
                        const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' && const_var.loginSession == true &&
                           <div className='new-links-redirect'>
                                <div className="link-divider"></div>
                                <a className="additional-link2 underline" onClick={() => {window.open(const_var.crmSetting.web_url+'/manufacturer_active_discount', '_blank')}}>Explore Manufacturer’s Deals  <i className="icon-arrow-thin-right hide-resp"></i></a>
                            </div>
                    }
                    {/* <div className='discounts-close' onClick={() => dispatch(handleShowDiscountsPanel())}>
                        <i className='icon-close'></i>
                    </div> */}
                </div>
            }
        </>
    )
}
 
export default Discounts